import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

export const RootContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Container = styled(TableContainer)({
  marginTop: 30,
  borderRadius: '8px',
  borderWidth: '1px 1px 0 1px',
  borderStyle: 'solid',
  borderColor: '#B0B0B0',
});

export const StatusBox = styled('div')({
  textAlign: 'center',
  padding: '8px 10px',
  borderRadius: '20px',
});

export const HeadRowStyled = styled(TableRow)({
  backgroundColor: '#E7E7E7',
});

export const HeadCellStyled = styled(TableCell)({
  fontWeight: 600,
  fontSize: '0.9rem',
});

export const BodyCellStyled = styled(TableCell)({
  borderWidth: '1px 0px 1px 0px',
  borderStyle: 'solid',
  borderColor: '#B0B0B0',
  padding: '0 16px',
  height: '58px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: 0,
  '&: hover': {
    cursor: 'pointer',
  },
});

export const TableRowStyled = styled(TableRow)({
  height: '48px',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
  },
});

export const NoTicketsMsg = styled(Typography)({
  color: '#8D8D8D',
  marginTop: 20,
  fontSize: '1.1rem',
});
